import { useLang } from "@/i18n";

export const Marquee = () => {
  const { t } = useLang();
  const items = [...t.marquee, ...t.marquee];
  return (
    <div data-testid="editorial-marquee" className="relative border-y border-white/10 bg-[#0A0A0C] py-7 overflow-hidden">
      <div className="marquee-track flex w-max whitespace-nowrap">
        {items.map((w, i) => (
          <span key={i} className="flex items-center font-display font-bold uppercase text-3xl sm:text-5xl tracking-tight">
            <span className={i % 2 ? "text-transparent [-webkit-text-stroke:1px_#a1a1aa]" : "text-white"}>{w}</span>
            <svg viewBox="0 0 20 20" className="mx-8 h-4 w-4 sm:h-5 sm:w-5 fill-red-600"><path d="M10 0 20 10 10 20 0 10Z" /></svg>
          </span>
        ))}
      </div>
      <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-[#0A0A0C] to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-[#0A0A0C] to-transparent" />
    </div>
  );
};
